// Map des sports -> icône (emoji)
export const SPORT_ICON_MAP: Record<string, string> = {
  football: '⚽',
  soccer: '⚽',
  basketball: '🏀',
  rugby: '🏈',
  'american football': '🏈',
  baseball: '⚾',

  // bonus (si besoin)
  handball: '🤾',
  volleyball: '🏐',
  hockey: '🏒',
};

export function normalizeSport(raw?: string): string {
  return (raw ?? '').trim().toLowerCase();
}

export function getSportIcon(sport?: string, fallback: string = '🏆'): string {
  const key = normalizeSport(sport);
  return SPORT_ICON_MAP[key] ?? fallback;
}
